import { type APIs } from './core/api';
import { type OurContext } from './core/context';
import { type ParsedClaims } from './core/context/claims';

export async function getValidatedConfig(
  context: OurContext,
  apis: APIs
): Promise<ParsedClaims | null> {
  const claims = await apis.validateClaims(context, context.apiAuth);

  if (claims == null) {
    return null;
  }
  return { ...claims };
}
